import { render, staticRenderFns } from "./AuthoritativeCertificationContentItem.vue?vue&type=template&id=78824d11&scoped=true&"
import script from "./AuthoritativeCertificationContentItem.vue?vue&type=script&lang=js&"
export * from "./AuthoritativeCertificationContentItem.vue?vue&type=script&lang=js&"
import style0 from "./AuthoritativeCertificationContentItem.vue?vue&type=style&index=0&id=78824d11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78824d11",
  null
  
)

export default component.exports